import { render, staticRenderFns } from "./PasoTresComponent.vue?vue&type=template&id=e48e8cc2"
import script from "./PasoTresComponent.vue?vue&type=script&lang=js"
export * from "./PasoTresComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports